import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface CardProps {
	title?: string;
	children: ReactNode;
	className?: string;
}

export const Card: FC<CardProps> = ({ title, children, className = '' }) => (
	<div className={classNames(styles.wrapper, className)}>
		{!!title && <p className={styles.wrapper__title}>{title}</p>}
		{children}
	</div>
);
